<template>
    <section id="common_banner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="common_bannner_text">
                        <h2>{{ $t('Booking Confirmation') }}</h2>
                        <ul>
                            <li>
                                <a href="/flight-search-result">
                                    {{ $t('Flight search result') }}
                                </a>
                            </li>
                            <li>
                                <span>
                                    <i class="fas fa-circle"></i>
                                </span>
                                <a href="/flight-booking-submission">
                                    {{ $t('Passengers') }}
                                </a>
                            </li>
                            <li><span><i class="fas fa-circle"></i></span> {{ $t('Booking Confirmation') }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

export default {
    name: "BookingConfirmationBanner"
};
</script>